import _ from 'lodash'
import React, { Component } from 'react';
import { connect } from 'react-redux'
import RepeatItem from './RepeatItem.js'
import { setRepeatFields } from './actions/index.js'

class RepeatField extends Component {

  constructor(props) {
    super(props);

    this.state = {
      openRow: 'none'
    }
  }

  handleClickSwap( indexA, indexB ){
    const { fields } = this.props;
    fields.swap( indexA, indexB )
  }

  handleRowClick( value ){
    this.setState({
      openRow: value
    })
  }

  addItemRow(e){
    e.preventDefault();

    const { fields, parentKey, state } = this.props
    var nextRowIndex = fields.length;
    this.setState({ openRow: nextRowIndex });

    if ( state.sppbForm.form == 'mainForm' ) {
      this.props.setRepeatFields( parentKey, nextRowIndex )
    }

    fields.push({})
  }

  removeItemRowClick(itemIndex){
    const { fields } = this.props
    fields.remove(itemIndex)
  }

  render(){
    const { fields, flOptions } = this.props

    let thisFormName = this.props.meta.form

    return(
      <div className="sp-pagebuilder-grouped-wrap">
        {
          this.state.openRow == 'none' &&
          <div className="sppb-add-repeat-item-header">
            <label>{ flOptions.title }</label>
            <button className="sppb-add-repeat-item-btn" type="button" onClick={ this.addItemRow.bind(this) }><i className="fa fa-plus" /> Add Item</button>
          </div>
        }
        {
          fields.map( (element,index) => {

            if (this.state.openRow == 'none' || this.state.openRow == index) {
              return(
                <RepeatItem
                  key       = { index }
                  flOptions = { flOptions }
                  fields    = { fields }
                  element   = { element }
                  thisFormName  = { thisFormName }
                  parentKey = { this.props.parentKey }
                  index     = { index }
                  openRow   = { this.state.openRow }
                  onHandleRowClick            = { this.handleRowClick.bind(this) }
                  onHandleRemoveItemRowClick  = { this.removeItemRowClick.bind(this) }
                />
              )
            }
            return;
          }
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    setRepeatFields: ( fieldName, rfieldIndex ) => {
      dispatch( setRepeatFields( fieldName, rfieldIndex ) )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RepeatField);



// WEBPACK FOOTER //
// ./src/helpers/form/RepeatField.js